import React from 'react'
import { useTranslation } from 'react-i18next'

import './footer.css'

const getCurrentYear = () => new Date().getFullYear()

const Footer = () => {
  const { t } = useTranslation()
  const year = getCurrentYear()
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">© {year} Pic-nic d&apos;Opale</span>
            </div>
            <div className="footer4-footer-links">
              {/*<span className="footer4-text11 thq-body-small">{t('footer.privacy')}</span>*/}
              {/*<span className="thq-body-small">{t('footer.terms')}</span>*/}
              <span className="thq-body-small">{t('footer.cookies')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
